import axios from '@/axios-service';
import { ResponseContent, responseContent } from '../types';
import { CountryDTO, City, CityRequest, CityDTO } from './types';
import { classToPlain } from 'class-transformer';

const MS_URL = 'senana/api/location';
const responseAsCountryDTO = responseContent(CountryDTO);
const responseAsCityDTO = responseContent(CityDTO);

export const getCitiesByCountryAndState = async (country: string, state: string): Promise<ResponseContent<City[]>> => axios
  .get(`${MS_URL}/countries/${country}/states/${state}/cities`)
  .then(response => ({ data: response.data } as ResponseContent<City[]>))

export const getStatesByCountry = async (country: string): Promise<ResponseContent<CountryDTO>> => axios
  .get(`${MS_URL}/${country}/states`)
  .then(responseAsCountryDTO)

export const findCityByCentroid = async (cityRequest: CityRequest): Promise<ResponseContent<CityDTO>> => axios
  .post(`${MS_URL}`, classToPlain(cityRequest))
  .then(responseAsCityDTO)
